import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../css/Aboutus.css";
import Footer from "../../Footer/Footer";
import { FaBuildingShield } from "react-icons/fa6";
import { FaLock } from "react-icons/fa";
import { GiArtificialIntelligence, GiPadlock } from "react-icons/gi";
import {
  FaCertificate,
  FaChartBar,
  FaThumbsUp,
  FaMoneyBillWave,
} from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import data from "../../ApiUrl/meta_api";
import AOS from "aos";
import "aos/dist/aos.css";

const PRIMARY = "#19194c";
const SECONDARY = "#ffc107";

const InternshipPage = () => {
  const navigate = useNavigate();
  const [meta, setMeta] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [activeTab, setActiveTab] = useState("versionControl");
  const [expandedTool, setExpandedTool] = useState(null);

  const handleToggle = (index) => {
    setExpandedTool(expandedTool === index ? null : index);
  };

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-out-cubic",
      once: false,
      offset: 100,
      delay: 100,
    });

    // Directly access internship_page from data
    const InternshipMeta = data[0]?.internship_page;

    // Set meta state if InternshipMeta exists
    if (InternshipMeta) {
      setMeta(InternshipMeta);
    }
  }, []);

  const handleShowModal = () => setShowModal(true);
  // eslint-disable-next-line
  const handleFormSubmit = (e) => {
    e.preventDefault();
    alert("Form submitted!");
    setShowModal(false);
  };

  const internshipExamples = [
    {
      title: "Snowflake",
      subtitle: "Retail Sales Warehouse",
      description:
        "Built a retail inventory dashboard using Snowflake's data warehouse for real-time stock updates.",
      icon: <FaBuildingShield size={50} color="#0663ad" />,
      // gradient: "linear-gradient(135deg, #0663ad 0%, #008cff 100%)",
    },
    {
      title: "AI",
      subtitle: "Spam Detection Tool",
      description:
        "Created an ML model to detect spam emails with 96% accuracy using Python and TensorFlow.",
      icon: <GiArtificialIntelligence size={50} color="#0663ad" />,
      gradient: "linear-gradient(135deg, #ffca28 0%, #ffb300 100%)",
    },
    {
      title: "Oracle",
      subtitle: "Database Tuning",
      description:
        "Optimized SQL queries in Oracle DB for a logistics company, reducing latency by 40%.",
      icon: <GiPadlock size={50} color="#0663ad" />,
      gradient: "linear-gradient(135deg, #ffd54f 0%, #ffc107 100%)",
    },
    {
      title: "Cyber Security",
      subtitle: "Log Analysis",
      description:
        "Performed log forensics to detect suspicious activity patterns using ELK Stack.",
      icon: <FaLock size={50} color="#0663ad" />,
      gradient: "linear-gradient(135deg, #ffe082 0%, #ffca28 100%)",
    },
  ];

  const perks = [
    {
      icon: <FaCertificate />,
      title: "Internship Certificate",
      desc: "Industry-recognized certification",
    },
    {
      icon: <FaChartBar />,
      title: "Project Report & Feedback",
      desc: "Detailed performance analysis",
    },
    {
      icon: <FaThumbsUp />,
      title: "Letter of Recommendation",
      desc: "Professional endorsement",
    },
    {
      icon: <FaMoneyBillWave />,
      title: "Optional Stipend",
      desc: "₹3K–₹10K performance-based",
    },
  ];

  const tools = [
    {
      name: "Git",
      description:
        "Distributed version control system for tracking code changes.",
      icon: "git",
      benefits: [
        "Efficient team collaboration",
        "Track changes, branches, and merges",
        "Contribute to open-source projects",
      ],
    },
    {
      name: "JIRA",
      description: "Project management and issue-tracking tool by Atlassian.",
      icon: "kanban",
      benefits: [
        "Agile (Scrum/Kanban) project tracking",
        "Log bugs and manage tasks",
        "Transparent team workflows",
      ],
    },
    {
      name: "Jenkins",
      description: "Open-source automation server for CI/CD pipelines.",
      icon: "gear",
      benefits: [
        "Automate builds, tests, and deployments",
        "Learn DevOps practices",
        "Ensure error-free software releases",
      ],
    },
    {
      name: "Google Colab",
      description: "Cloud-based Jupyter notebook environment",
      icon: "google",
      features: [
        "No setup required - runs in cloud",
        "Free GPU/TPU acceleration",
        "Real-time collaboration",
      ],
      useCases: [
        "Training ML models for research",
        "Analyzing large datasets",
        "AI/ML experiments collaboration",
      ],
    },
    {
      name: "SQL Developer",
      description: "Graphical database IDE for SQL databases",
      icon: "database",
      features: [
        "Multiple database connections",
        "Query builder and execution",
        "Performance tuning tools",
      ],
      useCases: [
        "Customer data analysis",
        "Database schema design",
        "Complex query reporting",
      ],
    },
  ];

  return (
    <HelmetProvider>
      <div
        className="min-vh-100"
        style={{ backgroundColor: "#ffffff", overflowX: "hidden" }}
      >
        <Helmet>
          <title>{meta?.title || "Internship - Berlin Technovation"}</title>
          <meta
            name="description"
            content={
              meta?.meta?.meta1?.content ||
              "Join a future-ready internship experience where innovation meets impact. Collaborate with top professionals who are shaping the future of their industries, and gain hands-on experience through meaningful, real-world projects."
            }
          />
        </Helmet>

        {/* Hero Section */}
        <div
          style={{ width: "100%" }}
          data-aos="fade-down"
          data-aos-delay="200"
        >
          <div
            className="position-relative"
            style={{
              backgroundImage: `url(${require("../../Img/images/BannerImage/InternshipBanner.jpg")})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              height: "350px",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* Overlay */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.6)",
                zIndex: 1,
              }}
            ></div>

            {/* Centered Heading */}
            <div
              className="position-absolute top-50 start-50 translate-middle text-center"
              style={{ zIndex: 2 }}
              data-aos="zoom-in"
              data-aos-delay="400"
            >
              <h1 className="fw-bold" style={{ color: "#008cff" }}>
                Internship
              </h1>
            </div>

            {/* Breadcrumb */}
            <div
              className="container h-100 d-flex align-items-end pb-4"
              style={{ zIndex: 2, position: "relative" }}
              data-aos="fade-up"
              data-aos-delay="600"
            >
              <nav aria-label="breadcrumb">
                <ol
                  className="breadcrumb mb-0 px-3 py-2 rounded d-flex align-items-center"
                  style={{
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                    backdropFilter: "blur(4px)",
                    display: "flex",
                  }}
                >
                  <li className="breadcrumb-item d-flex align-items-center">
                    <button
                      onClick={() => navigate("/")}
                      className="btn btn-link p-0 text-decoration-none"
                      style={{
                        color: "#0663ad",
                        fontWeight: "bold",
                        background: "none",
                        border: "none",
                      }}
                    >
                      Home
                    </button>
                  </li>
                  <li
                    className="breadcrumb-item active d-flex align-items-center"
                    aria-current="page"
                    style={{ color: "black" }}
                  >
                    Internship
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>

        {/* Features Section */}
        <div className="py-5" data-aos="fade-up" data-aos-delay="200">
          <div className="container">
            <div className="row align-items-center gy-5">
              <div
                className="col-12 col-lg-6"
                data-aos="fade-right"
                data-aos-delay="300"
              >
                <h2 className="text-start mb-4">
                  <span style={{ color: "#0663ad"}}>
                    Elevate Your Career with a{" "}
                  </span>
                  <span className="text-black">Real-World Internship</span>
                </h2>
                <div className="section-divider  mb-4"></div>
                <p className="mb-4" data-aos="fade-up" data-aos-delay="400">
                  Join a future-ready internship experience where innovation
                  meets impact. Collaborate with top professionals who are
                  shaping the future of their industries, and gain hands-on
                  experience through meaningful, real-world projects. This is
                  your opportunity to expand your network by connecting with
                  mentors, peers, and industry leaders who inspire growth.
                  You'll work in a dynamic environment that challenges you to
                  think creatively and act boldly. Build your dream portfolio
                  and take a confident step toward a successful and fulfilling
                  career.
                </p>
                <button
                  className="btn text-white px-4 py-2 transition-transform duration-300 hover-scale"
                  style={{ backgroundColor: "#0663ad" }}
                  onClick={handleShowModal}
                  data-aos="zoom-in"
                  data-aos-delay="450"
                >
                  Apply Now
                </button>
              </div>
              <div
                className="col-12 col-lg-6"
                data-aos="fade-left"
                data-aos-delay="300"
              >
                <div
                  className="shadow-sm rounded-3"
                  style={{
                    background: "rgba(255, 255, 255, 0.9)",
                    backdropFilter: "blur(10px)",
                  }}
                >
                  <img
                    src={require("../../Img/images/internship-intern.jpeg")}
                    alt="Real-World Internship"
                    className="img-fluid rounded-3"
                    style={{ objectFit: "cover",height:"400px",width:"100%",maxWidth:"500px" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Live Examples Section */}
        <div className="py-5 bg-light" data-aos="fade-up" data-aos-delay="200">
          <div className="container">
            <h2
              className="text-center mb-4"
              data-aos="zoom-in"
              data-aos-delay="300"
            >
              <span style={{ color: "#0663ad" }}>Live Internship</span>{" "}
              <span className="text-dark">Examples</span>
            </h2>
             <div className="section-divider  mb-4"></div>
            <div className="row g-4">
              {internshipExamples.map((example, index) => (
                <div
                  key={index}
                  className="col-12 col-md-6 col-lg-3"
                  data-aos="fade-up"
                  data-aos-delay={400 + index * 100}
                >
                  <div className="h-100 p-4 rounded-3 shadow-sm bg-white border-0 position-relative transition-transform duration-300 hover-scale">
                    <div
                      className="position-absolute top-0 start-0 w-100 h-100"
                      style={{ zIndex: 0 }}
                    ></div>
                    <div className="text-center position-relative">
                      <div
                        className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                        style={{
                          width: "80px",
                          height: "80px",
                          zIndex: 1,
                        }}
                      >
                        {example.icon}
                      </div>
                      <h4 className="fw-bold mb-1" >
                        {example.title}
                      </h4>
                      <p className=" mb-2">{example.subtitle}</p>
                      <p className="mb-0">{example.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Perks Section */}
        <div className="py-5" data-aos="fade-up" data-aos-delay="200">
          <div className="container">
            <h2
              className="text-center mb-4"
              data-aos="zoom-in"
              data-aos-delay="300"
            >
              <span style={{ color: "#0663ad" }}>Exclusive</span>{" "}
              <span className="text-dark">Perks</span>
            </h2>
            <div className="section-divider  mb-4"></div>
            <div className="row g-5 align-items-center">
              <div
                className="col-12 col-md-6"
                data-aos="fade-right"
                data-aos-delay="400"
              >
                <div
                  className="shadow-sm rounded-3"
                  style={{
                    background: "rgba(255, 255, 255, 0.9)",
                    backdropFilter: "blur(10px)",
                  }}
                >
                  <img
                    src={require("../../Img/images/internship-perks.jpeg")}
                    alt="Exclusive Perks"
                    className="img-fluid rounded-3"
                    style={{ objectFit: "cover" }}
                  />
                </div>
              </div>
              <div
                className="col-12 col-md-6"
                data-aos="fade-left"
                data-aos-delay="400"
              >
                <div className="d-grid gap-4">
                  {perks.map((perk, index) => (
                    <div
                      key={index}
                      className="d-flex align-items-center"
                      data-aos="fade-up"
                      data-aos-delay={450 + index * 50}
                    >
                      <div className="me-3 fs-3" style={{ color: "#008cff" }}>
                        {perk.icon}
                      </div>
                      <div>
                        <h5
                          className="fw-semibold mb-1 text-dark "
                        
                        >
                          {perk.title}
                        </h5>
                        <p className="text-muted mb-0">{perk.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Tools Section */}
        <div className="py-5 bg-light" data-aos="fade-up" data-aos-delay="200">
          <div className="container">
            <div
              className="text-center mb-5"
              data-aos="zoom-in"
              data-aos-delay="300"
            >
              <h2 className="mb-4">
                <span style={{ color: "#0663ad" }}>Internship Essential</span>{" "}
                <span className="text-dark">Tools</span>
              </h2>
               <div className="section-divider  mb-4"></div>
              <p
                className="lead"
                data-aos="fade-up"
                data-aos-delay="400"
              >
                Master these tools to excel in your software development
                internship
              </p>
            </div>

            <div className="px-3 px-md-5">
              {/* Tab Navigation */}
              <div
                className="d-flex justify-content-center mb-4 flex-wrap overflow-auto gap-2"
                data-aos="fade-up"
                data-aos-delay="450"
              >
                <button
                  className={`btn text-nowrap px-4 py-2 rounded border border-dark ${
                    activeTab === "versionControl"
                      ? "bg-dark text-white"
                      : "bg-white"
                  } transition-colors duration-300`}
                  onClick={() => setActiveTab("versionControl")}
                >
                  <i className="bi bi-git me-2"></i>Version Control
                </button>
                <button
                  className={`btn text-nowrap px-4 py-2 rounded border border-dark ${
                    activeTab === "dataScience"
                      ? "bg-dark text-white"
                      : "bg-white"
                  } transition-colors duration-300`}
                  onClick={() => setActiveTab("dataScience")}
                >
                  <i className="bi bi-bar-chart-line me-2"></i>Data Science
                </button>
              </div>

              {/* Tab Content */}
              <div>
                {activeTab === "versionControl" && (
                  <div className="d-flex flex-wrap gap-4 justify-content-center">
                    {tools.slice(0, 3).map((tool, index) => (
                      <div
                        key={index}
                        className="bg-white p-4 rounded-3 shadow-sm border-0 transition-transform duration-300 hover-scale"
                        style={{ width: "100%", maxWidth: "350px" }}
                        data-aos="fade-up"
                        data-aos-delay={500 + index * 100}
                      >
                        <div
                          className="d-flex align-items-center py-3 text-white rounded"
                          style={{ backgroundColor: "#0663ad"}}
                        >
                          <i
                            className={`bi bi-${tool.icon} fs-3 me-3 ms-3`}
                            // style={{ color: SECONDARY }}
                          ></i>
                          <h5 className="mb-0">{tool.name}</h5>
                        </div>
                        <div className="mt-3">
                          <p className="text-muted mb-3">{tool.description}</p>
                          <div
                            className="d-flex justify-content-between align-items-center py-2 border-top cursor-pointer"
                            onClick={() => handleToggle(index)}
                          >
                            <small className="fw-semibold">
                              Internship Benefits
                            </small>
                            <i
                              className={`bi bi-chevron-${
                                expandedTool === index ? "up" : "down"
                              }`}
                            ></i>
                          </div>
                          {expandedTool === index && (
                            <ul className="list-unstyled mt-2">
                              {tool.benefits.map((benefit, i) => (
                                <li
                                  key={i}
                                  className="d-flex align-items-center mb-2"
                                >
                                  <i
                                    className="bi bi-check-circle-fill me-2"
                                    style={{ color:"#0663ad" }}
                                  ></i>
                                  {benefit}
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                {activeTab === "dataScience" && (
                  <div className="d-flex flex-wrap gap-4 justify-content-center">
                    {tools.slice(3).map((tool, index) => (
                      <div
                        key={index}
                        className="bg-white p-4 rounded-3 shadow-sm border-0 transition-transform duration-300 hover-scale"
                        style={{ width: "100%", maxWidth: "500px" }}
                        data-aos="fade-up"
                        data-aos-delay={500 + index * 100}
                      >
                        <div
                          className="d-flex align-items-center py-3 text-white rounded"
                          style={{ backgroundColor: "#0663ad"}}
                        >
                          <i
                            className={`bi bi-${tool.icon} fs-3 me-3 ms-3`}
                         
                          ></i>
                          <h5 className="mb-0">{tool.name}</h5>
                        </div>
                        <div className="mt-3">
                          <p className="text-muted mb-3">{tool.description}</p>
                          <div
                            className="d-flex justify-content-between align-items-center py-2 border-top cursor-pointer"
                            onClick={() => handleToggle(index + 3)}
                          >
                            <small className="fw-semibold">Key Features</small>
                            <i
                              className={`bi bi-chevron-${
                                expandedTool === index + 3 ? "up" : "down"
                              }`}
                            ></i>
                          </div>
                          {expandedTool === index + 3 && (
                            <ul className="list-unstyled mt-2 mb-3">
                              {tool.features.map((feature, i) => (
                                <li
                                  key={i}
                                  className="d-flex align-items-center mb-2"
                                >
                                  <i
                                    className="bi bi-check-circle-fill me-2"
                                    style={{ color:"#0663ad"}}
                                  ></i>
                                  {feature}
                                </li>
                              ))}
                            </ul>
                          )}
                          <div
                            className="d-flex justify-content-between align-items-center py-2 border-top cursor-pointer"
                            onClick={() => handleToggle(index + 100)}
                          >
                            <small className="fw-semibold">
                              Internship Use Cases
                            </small>
                            <i
                              className={`bi bi-chevron-${
                                expandedTool === index + 100 ? "up" : "down"
                              }`}
                            ></i>
                          </div>
                          {expandedTool === index + 100 && (
                            <ul className="list-unstyled mt-2">
                              {tool.useCases.map((useCase, i) => (
                                <li
                                  key={i}
                                  className="d-flex align-items-center mb-2"
                                >
                                  <i
                                    className="bi bi-check-circle-fill me-2"
                                    style={{ color:"#0663ad" }}
                                  ></i>
                                  {useCase}
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              
            </div>
          </div>
        </div>

        {/* Apply Form */}
        {showModal && (
        <div
            className="modal modal-enhanced fade show d-block"
            style={{ backgroundColor: "rgba(0,0,0,0.7)" }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div
                className="modal-content modal-content-enhanced"
                style={{ maxHeight: "600px", overflowY: "auto" }}
                data-aos="zoom-in"
              >
                <div
                  className="modal-header border-0 pb-0"
                  style={{
                      background: "linear-gradient(135deg, #0663ad, #008cff)",
                    padding: "0.75rem 1rem",
                  }}
                >
                  <h3
                    className="modal-title text-white mb-2 fw-bold"
                    style={{ fontSize: "1rem" }}
                  >
                    <i
                      className="bi bi-mortarboard me-2"
                    ></i>
                    Registration Form
                  </h3>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={() => setShowModal(false)}
                    style={{ fontSize: "0.7rem" }}
                  ></button>
                </div>
                <div
                  className="modal-body p-3"
                  style={{
                    background: "linear-gradient(180deg, #f8f9fa, white)",
                  }}
                >
                  <div className="text-center mb-3">
                    <div
                      className="d-inline-flex align-items-center justify-content-center  rounded-circle mb-2"
                      style={{ width: "50px", height: "50px",background:"#008cff" }}
                    >
                      <i className="bi bi-book text-dark fs-4"></i>
                    </div>
                    <p className="text-muted" style={{ fontSize: "0.8rem" }}>
                      Ready to start your learning journey?
                    </p>
                  </div>

                  <form>
                    <div className="mb-2">
                      <label
                        className="form-label fw-semibold text-dark"
                        style={{ fontSize: "0.8rem" }}
                      >
                        Full Name
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-enhanced form-control-sm"
                        required
                        placeholder="Enter your full name"
                      />
                    </div>

                    <div className="mb-2">
                      <label
                        className="form-label fw-semibold text-dark"
                        style={{ fontSize: "0.8rem" }}
                      >
                        Email Address
                      </label>
                      <input
                        type="email"
                        className="form-control form-control-enhanced form-control-sm"
                        required
                        placeholder="Enter your email address"
                      />
                    </div>

                    <div className="mb-2">
                      <label
                        className="form-label fw-semibold text-dark"
                        style={{ fontSize: "0.8rem" }}
                      >
                        Mobile Number
                      </label>
                      <input
                        type="number"
                        className="form-control form-control-enhanced form-control-sm"
                        required
                        maxLength={10}
                        pattern="\d{10}"
                        placeholder="Enter your mobile number"
                      />
                    </div>

                    <div className="mb-3">
                      <label
                        className="form-label fw-semibold text-dark"
                        style={{ fontSize: "0.8rem" }}
                      >
                        Send Message
                      </label>
                      <textarea
                        id="message"
                        className="form-control form-control-sm"
                        rows="3"
                        placeholder="Type your message here..."
                        required
                      ></textarea>
                    </div>

                    <div className="d-flex gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-outline-secondary px-3 py-1 rounded-pill"
                        onClick={() => setShowModal(false)}
                        style={{ fontSize: "0.8rem" }}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-submit text-white px-3 py-1 rounded-pill"
                        style={{
                          fontSize: "0.8rem",
                          backgroundColor: "#0663ad",
                          transition: "all 0.3s ease",
                        }}
                       
                      
                      >
                        <i className="bi bi-send me-1"></i>
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}

        <Footer />
      </div>
    </HelmetProvider>
  );
};

export default InternshipPage;
